import "../../../styles/tanimlar.css";
import { uiState } from "../../state/uiState.js";
import { showDialogOverlay, hideDialogOverlay } from "../../utils/dialogOverlay.js";

const API = "/api";

const KATEGORILER = [
	// Demirbaş tanımları
	{ key: "departman",           label: "Demirbaş Departmanı", grup: "demirbas", endpoint: "/departmanlar" },
	{ key: "urun_grubu",          label: "Ürün Grubu",          grup: "demirbas", endpoint: "/urun-grubu-tanimlari" },
	{ key: "urun_alt_grubu",      label: "Ürün Alt Grubu",      grup: "demirbas", endpoint: "/urun-alt-grubu-tanimlari" },
	{ key: "urun_cinsi",          label: "Ürün Cinsi",          grup: "demirbas", endpoint: "/urun-cinsi-tanimlari" },
	{ key: "marka",               label: "Marka",               grup: "demirbas", endpoint: "/marka-tanimlari" },
	{ key: "model",               label: "Model",               grup: "demirbas", endpoint: "/model-tanimlari" },
	{ key: "urun_durumu",         label: "Ürün Durumu",         grup: "demirbas", endpoint: "/urun-durumlari" },
	{ key: "zimmet_durumu",       label: "Zimmet Durumu",       grup: "demirbas", endpoint: "/zimmet-durumlari" },
	{ key: "lokasyon",            label: "Lokasyon",            grup: "demirbas", endpoint: "/lokasyonlar" },
	{ key: "oda",                 label: "Oda",                 grup: "demirbas", endpoint: "/odalar" },
	{ key: "yer",                 label: "Yer",                 grup: "demirbas", endpoint: "/yerler" },
	{ key: "amortisman",         label: "Faydal\u0131 \u00d6m\u00fcr",      grup: "demirbas", endpoint: "/amortisman-tanimlari", special: true },
	// Kişi tanımları
	{ key: "kisi_departman",      label: "Kişi Departmanı",     grup: "kisi",     endpoint: "/kisi-departmanlari" },
	{ key: "unvan",               label: "Ünvan",               grup: "kisi",     endpoint: "/unvanlar" },
];

let initialized = false;
let counts = {};
let listAbortController = null;
let listRequestId = 0;

function escapeHtml(value) {
	return String(value ?? "")
		.replaceAll("&", "&amp;")
		.replaceAll("<", "&lt;")
		.replaceAll(">", "&gt;")
		.replaceAll('"', "&quot;")
		.replaceAll("'", "&#39;");
}

export async function renderTanimlarPage() {
	if (!document.getElementById("tablo-tanimlar-view")) {
		document.getElementById("page-content").insertAdjacentHTML("beforeend", '<div id="tablo-tanimlar-view"></div>');
	}
	const view = document.getElementById("tablo-tanimlar-view");
	if (!view) return;

	if (!initialized) {
		initialized = true;
		uiState["tablo-tanimlar"].activeCategory = null;
	}

	await fetchAllCounts();
	renderLayout(view);
	if (!view._boundEvents) {
		view._boundEvents = true;
		bindEvents(view);
	}

	const active = uiState["tablo-tanimlar"].activeCategory;
	if (active) selectKategori(active, view);
}

async function fetchAllCounts() {
	await Promise.all(
		KATEGORILER.map(async (kat) => {
			try {
				const res = await fetch(`${API}${kat.endpoint}${kat.special ? "?include_inactive=1" : ""}`);
				const data = await res.json();
				counts[kat.key] = data.items?.length ?? 0;
			} catch {
				counts[kat.key] = 0;
			}
		}),
	);
}

function renderLayout(view) {
	const demirbas = KATEGORILER.filter((k) => k.grup === "demirbas");
	const kisi = KATEGORILER.filter((k) => k.grup === "kisi");
	const active = uiState["tablo-tanimlar"].activeCategory;

	view.innerHTML = `
		<div class="tanim-layout">
			<div class="tanim-karti-alani">
				<div class="tanim-grup-label">Demirbaş Tanımları</div>
				<div class="tanim-card-grid">
					${demirbas.map((k) => kartHTML(k, active)).join("")}
				</div>
				<div class="tanim-grup-label">Kişi Tanımları</div>
				<div class="tanim-card-grid">
					${kisi.map((k) => kartHTML(k, active)).join("")}
				</div>
			</div>
			<div class="tanim-content" id="tanim-content" ${active ? "" : 'style="display:none;"'}>
				<div id="tanim-add-area"></div>
				<div id="tanim-liste-area"></div>
			</div>
		</div>
	`;
}

function kartHTML(kat, activeKey) {
	const isActive = kat.key === activeKey;
	const count = counts[kat.key] ?? 0;
	const safeLabel = escapeHtml(kat.label);
	return `
		<div class="tanim-card ${isActive ? "active" : ""}" data-key="${kat.key}">
			<div class="tanim-card-top">
				<span class="tanim-card-label" title="${safeLabel}">${safeLabel}</span>
				<span class="tanim-card-count">${count}</span>
			</div>
		</div>
	`;
}

function bindEvents(view) {
	view.addEventListener("click", (e) => {
		const card = e.target.closest(".tanim-card[data-key]");
		if (card) selectKategori(card.dataset.key, view);
	});

	view.addEventListener("click", (e) => {
		if (e.target.closest(".tanim-ekle-btn")) handleAdd(view);
	});

	view.addEventListener("click", (e) => {
		const editBtn = e.target.closest(".tanim-edit-btn");
		if (!editBtn) return;
		const key = uiState["tablo-tanimlar"].activeCategory;
		const kat = KATEGORILER.find((k) => k.key === key);
		if (!kat) return;
		const nameCell = editBtn.closest("tr")?.querySelector("td:nth-child(2)");
		openTanimEditDialog(kat, editBtn.dataset.id, nameCell?.textContent ?? "", view, {
			years: editBtn.dataset.years,
			usageCount: Number(editBtn.dataset.usageCount || 0),
		});
	});

	view.addEventListener("click", async (e) => {
		const statusBtn = e.target.closest(".tanim-status-btn");
		if (!statusBtn) return;
		statusBtn.disabled = true;
		try {
			const response = await fetch(`${API}/amortisman-tanimlari/${statusBtn.dataset.id}/durum`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ is_active: statusBtn.dataset.active !== "true" }),
			});
			const data = await response.json();
			if (!response.ok) throw new Error(data?.error || "Durum g\u00fcncellenemedi.");
			loadListe(KATEGORILER.find((item) => item.key === "amortisman"), view);
		} catch (error) {
			const feedback = view.querySelector("#tanim-feedback");
			if (feedback) feedback.textContent = error.message;
		} finally {
			statusBtn.disabled = false;
		}
	});

	view.addEventListener("keydown", (e) => {
		if (e.key === "Enter" && e.target.matches(".tanim-add-input")) handleAdd(view);
	});
}

function selectKategori(key, view) {
	uiState["tablo-tanimlar"].activeCategory = key;
	const kat = KATEGORILER.find((k) => k.key === key);
	if (!kat) return;

	view.querySelectorAll(".tanim-card").forEach((c) => c.classList.toggle("active", c.dataset.key === key));

	const content = view.querySelector("#tanim-content");
	if (content) content.style.display = "";

	renderAddForm(kat, view);
	loadListe(kat, view);
}

function renderAddForm(kat, view) {
	const area = view.querySelector("#tanim-add-area");
	if (!area) return;
	area.innerHTML = kat.special ? `
		<div class="tanim-add-row tanim-add-row--amortisman">
			<label class="tanim-add-label">Yeni Faydal&#305; &#214;m&#252;r</label>
			<input class="tanim-add-input" type="text" placeholder="Tan&#305;m ad&#305; girin..." maxlength="150" />
			<div class="tanim-years-control tanim-add-years-control">
				<input class="tanim-add-years" type="number" min="1" max="100" step="1" aria-label="Faydal&#305; &#246;m&#252;r y&#305;l&#305;" />
				<span>Y&#305;l</span>
			</div>
			<button class="tanim-ekle-btn btn-header-action btn-header-action--primary">
				<span class="material-icons">add</span>Ekle
			</button>
		</div>
		<div class="tanim-feedback" id="tanim-feedback"></div>
	` : `
		<div class="tanim-add-row">
			<label class="tanim-add-label">Yeni ${kat.label}</label>
			<input class="tanim-add-input" type="text" placeholder="${kat.label} adı girin..." maxlength="150" />
			<button class="tanim-ekle-btn btn-header-action btn-header-action--primary">
				<span class="material-icons">add</span>
				Ekle
			</button>
		</div>
		<div class="tanim-feedback" id="tanim-feedback"></div>
	`;
}

async function loadListe(kat, view) {
	const area = view.querySelector("#tanim-liste-area");
	if (!area) return;
	listAbortController?.abort();
	const controller = new AbortController();
	const requestId = ++listRequestId;
	listAbortController = controller;
	area.innerHTML = `<div class="tanim-loading">Yükleniyor...</div>`;

	try {
		const res = await fetch(`${API}${kat.endpoint}${kat.special ? "?include_inactive=1" : ""}`, {
			signal: controller.signal,
		});
		const data = await res.json();
		if (
			controller.signal.aborted
			|| requestId !== listRequestId
			|| uiState["tablo-tanimlar"].activeCategory !== kat.key
		) return;
		const items = data.items || [];

		counts[kat.key] = items.length;
		updateKartCount(view, kat.key, items.length);

		if (items.length === 0) {
			area.innerHTML = `<div class="tanim-empty">Henüz kayıt yok.</div>`;
			return;
		}

		if (kat.special) {
			area.innerHTML = `
				<table class="tanim-table tanim-table--amortisman">
					<thead><tr><th>ID</th><th>Ad</th><th>Y&#305;l</th><th>Kullan&#305;m</th><th>Durum</th><th>&#304;&#351;lemler</th></tr></thead>
					<tbody>${items.map((item) => {
						const safeName = escapeHtml(item.name);
						const isActive = Boolean(item.is_active);
						return `<tr>
							<td>${item.id}</td>
							<td><span class="tanim-cell-text" title="${safeName}">${safeName}</span></td>
							<td>${item.faydali_omur_yil}</td>
							<td>${item.kullanim_sayisi}</td>
							<td><span class="tanim-status tanim-status--${isActive ? "active" : "passive"}">${isActive ? "Aktif" : "Pasif"}</span></td>
							<td class="tanim-actions-cell">
								<button class="tanim-edit-btn" data-id="${item.id}" data-years="${item.faydali_omur_yil}" data-usage-count="${item.kullanim_sayisi}">D\u00fczenle</button>
								<button class="tanim-status-btn" data-id="${item.id}" data-active="${isActive}">${isActive ? "Pasife Al" : "Aktifle\u015ftir"}</button>
							</td>
						</tr>`;
					}).join("")}</tbody>
				</table>`;
			return;
		}

		area.innerHTML = `
			<table class="tanim-table">
				<thead>
					<tr>
						<th>ID</th>
						<th>Ad</th>
						<th>İşlemler</th>
					</tr>
				</thead>
				<tbody>
					${items.map((it) => {
						const safeName = escapeHtml(it.name);
						return `
						<tr>
							<td>${it.id}</td>
							<td><span class="tanim-cell-text" title="${safeName}">${safeName}</span></td>
							<td class="tanim-actions-cell">
								<button class="tanim-edit-btn" data-id="${it.id}" aria-label="Düzenle">
									<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
										<path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
										<path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
									</svg>
									Düzenle
								</button>
							</td>
						</tr>
					`;
					}).join("")}
				</tbody>
			</table>
		`;
	} catch (error) {
		if (error?.name === "AbortError" || requestId !== listRequestId) return;
		area.innerHTML = `<div class="tanim-empty">Veriler yüklenemedi.</div>`;
	} finally {
		if (listAbortController === controller) listAbortController = null;
	}
}

async function handleAdd(view) {
	const key = uiState["tablo-tanimlar"].activeCategory;
	const kat = KATEGORILER.find((k) => k.key === key);
	if (!kat) return;

	const input    = view.querySelector(".tanim-add-input");
	const feedback = view.querySelector("#tanim-feedback");
	const btn      = view.querySelector(".tanim-ekle-btn");
	const name = (input?.value || "").trim();
	if (!name) { input?.focus(); return; }
	const yearsInput = view.querySelector(".tanim-add-years");
	const years = yearsInput?.value ?? "";
	if (kat.special && (!/^\d+$/.test(years) || Number(years) < 1 || Number(years) > 100)) {
		if (feedback) feedback.textContent = "Faydal\u0131 \u00f6m\u00fcr 1 ile 100 aras\u0131nda tam say\u0131 olmal\u0131d\u0131r.";
		yearsInput?.focus();
		return;
	}

	if (btn) {
		btn.disabled = true;
		btn.innerHTML = `<span class="material-icons tanim-ekle-spin">refresh</span> Ekleniyor...`;
	}

	await new Promise((r) => setTimeout(r, 350));
	try {
		const res = await fetch(`${API}${kat.endpoint}`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(kat.special ? { name, faydali_omur_yil: Number(years) } : { name }),
		});
		const data = await res.json();

		if (!data.ok) {
			if (feedback) feedback.textContent = data.error || "Hata oluştu.";
			return;
		}

		if (input) input.value = "";
		if (yearsInput) yearsInput.value = "";
		if (feedback) feedback.textContent = "";
		loadListe(kat, view);
	} catch {
		if (feedback) feedback.textContent = "Sunucuya bağlanılamadı.";
	} finally {
		if (btn) {
			btn.disabled = false;
			btn.innerHTML = `<span class="material-icons">add</span> Ekle`;
		}
	}
}

function updateKartCount(view, key, count) {
	const card = view.querySelector(`.tanim-card[data-key="${key}"] .tanim-card-count`);
	if (card) card.textContent = count;
}

function ensureTanimEditDialog() {
	if (document.getElementById("tanimEditDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
		<dialog id="tanimEditDialog">
			<div class="edit-loading-overlay" hidden>
				<div class="edit-loading-spinner"></div>
				<span class="edit-loading-text">Kaydediliyor...</span>
			</div>
			<div class="tanim-edit-inner">
				<div class="tanim-edit-header">
					<h3 class="tanim-edit-title">Tanımı Düzenle</h3>
					<button class="tanim-edit-close" type="button" aria-label="Kapat">&#10005;</button>
				</div>
				<div class="tanim-edit-body">
					<div class="tanim-edit-field">
						<label class="tanim-edit-field-label">Ad</label>
						<input id="tanimEditInput" class="form-input" type="text" maxlength="150" />
						<span class="tanim-edit-error" id="tanimEditError"></span>
					</div>
					<div class="tanim-edit-field tanim-edit-years-field" hidden>
						<label class="tanim-edit-field-label">Faydal&#305; &#214;m&#252;r (Y&#305;l)</label>
						<div class="tanim-years-control">
							<input id="tanimEditYears" type="number" min="1" max="100" step="1" />
							<span>Y&#305;l</span>
						</div>
						<span class="tanim-edit-help"></span>
					</div>
				</div>
				<div class="tanim-edit-footer">
					<button class="tanim-edit-cancel" type="button">İptal</button>
					<button class="tanim-edit-save" type="button">Kaydet</button>
				</div>
			</div>
		</dialog>
	`);

	const dialog = document.getElementById("tanimEditDialog");
	dialog.addEventListener("click", (e) => {
		if (e.target.closest(".tanim-edit-close") || e.target.closest(".tanim-edit-cancel"))
			dialog.close();
	});
}

function openTanimEditDialog(kat, id, currentName, view, options = {}) {
	ensureTanimEditDialog();
	const dialog = document.getElementById("tanimEditDialog");
	const input = dialog.querySelector("#tanimEditInput");
	const error = dialog.querySelector("#tanimEditError");
	const overlay = dialog.querySelector(".edit-loading-overlay");
	const yearsField = dialog.querySelector(".tanim-edit-years-field");
	const yearsInput = dialog.querySelector("#tanimEditYears");
	const yearsHelp = dialog.querySelector(".tanim-edit-help");

	input.value = currentName;
	error.textContent = "";
	if (overlay) overlay.hidden = true;
	if (yearsField) yearsField.hidden = !kat.special;
	if (yearsInput) {
		yearsInput.value = kat.special ? String(options.years || "") : "";
		yearsInput.disabled = kat.special && options.usageCount > 0;
	}
	if (yearsHelp) {
		yearsHelp.textContent = options.usageCount > 0
			? "Kullan\u0131lan tan\u0131m\u0131n y\u0131l\u0131 de\u011fi\u015ftirilemez. Yeni tan\u0131m olu\u015fturun."
			: "";
	}

	// Önceki save listener'ı temizle
	const oldSave = dialog.querySelector(".tanim-edit-save");
	const newSave = oldSave.cloneNode(true);
	oldSave.replaceWith(newSave);

	newSave.addEventListener("click", async () => {
		const name = input.value.trim();
		if (!name) { input.focus(); return; }
		const years = yearsInput?.value ?? "";
		if (kat.special && (!/^\d+$/.test(years) || Number(years) < 1 || Number(years) > 100)) {
			error.textContent = "Faydal\u0131 \u00f6m\u00fcr 1 ile 100 aras\u0131nda tam say\u0131 olmal\u0131d\u0131r.";
			return;
		}

		showDialogOverlay(dialog);
		await new Promise((r) => setTimeout(r, 350));
		newSave.disabled = true;

		try {
			const res = await fetch(`${API}${kat.endpoint}/${id}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(kat.special ? { name, faydali_omur_yil: Number(years) } : { name }),
			});
			const data = await res.json();
			if (!data.ok) {
				error.textContent = data.error || "Hata oluştu.";
				return;
			}
			dialog.close();
			loadListe(kat, view);
		} catch {
			error.textContent = "Sunucuya bağlanılamadı.";
		} finally {
			hideDialogOverlay();
			newSave.disabled = false;
		}
	});

	dialog.showModal();
	input.select();
}
